import { request } from '@/shares/request';
export const batchV2 = {
  fetcher: ({ list }: { list: any | [] }) =>
    request(`/user/v1/wallet/batchV2`, {
      method: 'post',
      data: {
        list: list,
        nocache: true,
      },
    }),
  key: 'batchV2',
};
interface TransferDataV2Type {
  chain: string;
  from: string;
  to: string;
  amount: number;
  symbol: string;
  contract: string;
  publicKey: string;
  memo: string;
}

export const getTransferDataV2 = {
  fetcher: (params: TransferDataV2Type) =>
    request(`/user/wallet/getTransferDataV2`, {
      method: 'post',
      data: params,
    }),
  key: 'getTransferDataV2',
};
// 获取Solana 优先费
export const getComputeFeePrice = {
  fetcher: () =>
    request(`/operation/v1/bwb_claim/getComputeFeePrice`, {
      method: 'get',
    }),
  key: 'getComputeFeePrice',
};
